<template>
  <account>
    <div class="account-payment">
      <div class="container">
        <div class="header">
          <span>PAYMENT</span>
        </div>
        <div class="body">
          <div class="row">
            <div class="child">
              <base-input-type-1
                label="ACCOUNT NUMBER"
                placeholder="ACCOUNT NUMBER"
              ></base-input-type-1>
            </div>
          </div>

          <div class="row">
            <div class="child sort-code">
              <base-input-type-1
                label="Sort code"
                placeholder="SORT CODE"
              ></base-input-type-1>
            </div>
          </div>

          <div class="row">
            <div class="child twins-input">
              <base-input-type-1
                label="CITY"
                placeholder="CITY"
              ></base-input-type-1>
              <base-input-type-1
                label="ADDRESS"
                placeholder="ADDRESS"
              ></base-input-type-1>
            </div>
          </div>
          <div class="row">
            <div class="child twins-input">
              <base-input-type-1
                label="POSTAL CODE"
                placeholder="POSTAL CODE"
              ></base-input-type-1>
              <base-input-type-1
                label="COUNTRY"
                placeholder="COUNTRY"
              ></base-input-type-1>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="child submit">
            <base-button-type-1
              text="CANCEL"
              type-color="white"
            ></base-button-type-1>
            <base-button-type-1 text="OK"></base-button-type-1>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="header">
          <span>PAYPAL</span>
        </div>
        <div class="body">
          <div class="row">
            <div class="child">
              <base-input-type-1 label="USER ID"></base-input-type-1>
            </div>
          </div>
          <div class="row">
            <div class="child">
              <base-input-password-type-1
                label="PASSWORD"
                placeholder="PASSWORD"
              ></base-input-password-type-1>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="child submit">
            <base-button-type-1
              text="CANCEL"
              type-color="white"
            ></base-button-type-1>
            <base-button-type-1 text="OK"></base-button-type-1>
          </div>
        </div>
      </div>
    </div>
  </account>
</template>

<script>
import Account from './Account'
import BaseInputType1 from '../common/form-elemnets/BaseInputType1'
import BaseButtonType1 from '../common/form-elemnets/BaseButtonType1'
import BaseInputPasswordType1 from '../common/form-elemnets/BaseInputPasswordType1'

export default {
  name: 'account-payment',
  components: {
    BaseInputPasswordType1,
    BaseButtonType1,
    BaseInputType1,
    Account
  },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.account-payment {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  flex-wrap: wrap;
  .container {
    margin-bottom: 20px;
    width: 520px;
    height: auto;
    padding-bottom: 20px;
    background-color: #ffffff;
    border: solid 1px #e7e7e7;
    .header {
      width: 520px;
      height: 50px;
      background-color: #f5f5f5;
      border-bottom: solid 1px #e7e7e7;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      span {
        padding-left: 40px;
      }
    }

    .body {
      padding: 0 40px;
      margin-top: 44px;
      .row {
        margin-top: 15px;
        .child {
          &.sort-code {
            width: 100%;
            display: flex;
            justify-content: space-between;
            .base-input-type-1 {
              width: 108px;
            }
          }

          &.twins-input {
            width: 100%;
            display: flex;
            justify-content: space-between;
            .base-input-type-1 {
              width: 208px;
            }
          }
        }
      }
    }

    .footer {
      padding: 0 40px;
      margin-top: 30px;
      display: flex;
      justify-content: flex-end;
      .submit {
        display: flex;
        justify-content: space-between;
        width: 320px;
      }
    }
  }
}
</style>
